<template>
    <div class="nav" :class="type">
        <template v-if="config.menus">
            <div class="item">
                <router-link class="name" to="/"><span>{{$t('home')}}</span></router-link>
            </div>
            <div class="item" v-for="item in config.menus" :key="item.id">
                <p class="name" v-if="item.type == 0"><span>{{item.name}}</span></p>
                <router-link class="name" v-else-if="item.type == 1" :to="`/detail/${item.id}`"><span>{{item.name}}</span></router-link>
                <router-link class="name" v-else-if="item.type == 2" :to="`/list/${item.id}`"><span>{{item.name}}</span></router-link>
                <router-link class="name" v-else-if="item.type == 3" :to="`/repair/${item.id}`"><span>{{item.name}}</span></router-link>
                <router-link class="name" v-else-if="item.type == 4" :to="`/message/${item.id}`"><span>{{item.name}}</span></router-link>
                <router-link class="name" v-else-if="item.type == 5" :to="`/contact/${item.id}`"><span>{{item.name}}</span></router-link>
                <router-link class="name" v-else-if="item.type == 6" :to="`/photo/${item.id}`"><span>{{item.name}}</span></router-link>

                <!-- <router-link class="name" v-else to="/">{{item.name}}</router-link> -->
                <div class="list" v-if="item.list.length > 0">
                    <template v-for="_item in item.list">
                        <router-link class="link" :key="_item.id" v-if="_item.type == 1" :to="`/detail/${_item.id}`"><span>{{_item.name}}</span></router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 2" :to="`/list/${_item.id}`"><span>{{_item.name}}</span></router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 3" :to="`/repair/${_item.id}`"><span>{{_item.name}}</span></router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 4" :to="`/message/${_item.id}`"><span>{{_item.name}}</span></router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 5" :to="`/contact/${_item.id}`"><span>{{_item.name}}</span></router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 6" :to="`/photo/${_item.id}`"><span>{{_item.name}}</span></router-link>

                        <!-- <router-link class="link" :key="_item.id" v-else :to="`/`">{{_item.name}}</router-link> -->
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "navigation",
    props: ['type'],
    data() {
        return {};
    },
    computed: {
        ...mapState(['config']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.nav{
    display: flex;
    color: #fff;
    text-align: center;
    font-size: 16px;
    .item{
        flex: 1;
        position: relative;
        a{
            display: block;
        }
        .name{
            width: 100%;
            height: 30px;
            // line-height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 5px 0;
            border-right: 1px solid #6582b3;

            span{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
        }
        &:last-child{
            .name{
                border: none;
            }
        }
        &:hover{
            background: #1953b3;
            .list{
                display: block;
            }
        }
        .list{
            display: none;
            font-size: 14px;
            width: 100%;
            position: absolute;
            left: 0;
            top: 100%;
            padding: 3px 0;
            .link{
                height: 36px;
                // line-height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(25,83,129,0.5);
                margin-bottom: 3px;
                span{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                }
                &:hover{
                    background: #15428b;
                }
                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
    &.index{
        position: absolute;
        top: 50px;
        right: 50px;
        z-index: 2;
        .item{
            background-color: rgba(17,64,101,1);
            flex: auto;
            width: 130px;
            height: 40px;
            transition: background-color 0.6s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
            .name{
                height: 100%;
                margin: 0;
                border: none;
            }
            &:hover{
                background: #1677cb;
            }
        }
        .list{
            padding: 0;
            .link{
                background: #1677cb;
                margin: 0;
                &:hover{
                    background-color: rgba(0,0,0,0.1);
                }
            }
        }
    }
}
</style>